/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
// import { DropdownArrowIcon } from '../../../../../images/icons/DropdownArrow/DropdownArrow'
// import OptionsItem from '../../Step05/components/OptionsItem'
import OptionsCheckbox from '../../Step05/components/OptionsCheckbox'
import { Alert } from '../../../../common/Alert/Alert'
import { symbol } from '../../../../common/CurrencyFormat'

/**
 *     Step main container
 */
export default class VariationOptions extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            values: this.props.values,
            dirty: false,
            errorList: [],
            showErrorOfCovar: false,
        }
    }

    handleCheckbox = () => {
        return true
    }

    handleItemChange = (field: string, value: any) => {
        if (this.props.dirty) {
            this.props.dirty(true)
        }
        this.setState({
            values: { ...this.state.values, [field]: value },
            dirty: true,
        })
    }

    handleSubmit = (event: any) => {
        const {
            temporaryRemovalCoverValue,
            temporaryRemovalCover,
            incomingExhibitionLimit,
            outgoingExhibitionLimit,
        } = this.state.values
        let changeAdj = true
        event.preventDefault()
        let errorList: any = []
        if (errorList.length !== 0) {
            this.setState({ errorList: errorList })
        } else {
            if (temporaryRemovalCover &&
                parseFloat(temporaryRemovalCoverValue) <
                (parseFloat(incomingExhibitionLimit) + parseFloat(outgoingExhibitionLimit))) {
                changeAdj = false
                this.setState({ showErrorOfCovar: true })
            } else {
                changeAdj = true
                this.setState({ showErrorOfCovar: false })
            }

            if (changeAdj) {
                this.props.handleAdjustChangeOptions(this.state.values)
            }

            this.setState({ dirty: false, errorList: [] })
            if (this.props.dirty) {
                this.props.dirty(false)
            }
        }
    }

    render() {
        const {
            temporaryRemovalCover,
            exhibitionCover,
            temporaryRemovalCoverValue,
            incomingExhibitionLimit,
            outgoingExhibitionLimit,
            localExhibitions,
            internationalExhibitions,
            numberOfExhibitions,
            limitPerExhibition,
        } = this.state.values
        return (
            <div>
                <form
                    onSubmit={this.handleSubmit}
                    className={`${this.props.optionsOpen ? 'open' : null}
                     ${this.state.dirty ? 'plus57' : null}
                     ${(this.state.errorList.length) ? 'plus102' : null}`}
                >
                    <div
                        className={`variation__options__content options ${!this.props.optionsOpen ? 'closed' : null}`}
                    >
                        <OptionsCheckbox
                            id="terrorism"
                            title="Add terrorism cover"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.terrorism || false}
                            value={this.props.values.terrorism}
                        >
                            Insurers subscribe to Pool Re and, accordingly, if selected cover will extend to all
                            material damage and consequential loss sections.
                        </OptionsCheckbox>

                        <OptionsCheckbox
                            id="temporaryRemovalCover"
                            title="Temporary Removal Cover"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.temporaryRemovalCover || false}
                            value={this.props.values.temporaryRemovalCover}
                        >
                            Insurers subscribe to Pool Re and, accordingly, if selected cover will extend to all
                            material damage and consequential loss sections.
                        </OptionsCheckbox>

                        <div className={`options__item item_group ${!(temporaryRemovalCover) ? `hidden` : ``}`}>
                            <div className="input_group">
                                <div className="input_group_sec left">
                                    <div className="input_sec">
                                        <label>Cover Value</label>
                                        <div className="input">
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="temporaryRemovalCoverValue"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('temporaryRemovalCoverValue', v)
                                                }}
                                                value={temporaryRemovalCoverValue}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        {/* empty value */}
                                    </div>
                                </div>
                                <div className="input_group_sec right">
                                    <div className="input_sec">
                                        <label>Incoming Exhibition Limit</label>
                                        <div className="input">
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="incomingExhibitionLimit"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('incomingExhibitionLimit', v)
                                                }}
                                                value={incomingExhibitionLimit}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        <label>Outgoing Exhibition Limit</label>
                                        <div className="input">
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="outgoingExhibitionLimit"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('outgoingExhibitionLimit', v)
                                                }}
                                                value={outgoingExhibitionLimit}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <OptionsCheckbox
                            id="exhibitionCover"
                            title="Exhibition Cover"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.exhibitionCover || false}
                            value={this.props.values.exhibitionCover}
                        >
                            Insurers subscribe to Pool Re and, accordingly, if selected cover will extend to all
                            material damage and consequential loss sections.
                        </OptionsCheckbox>

                        <div className={`options__item item_group ${!(exhibitionCover) ? `hidden` : ``}`}>
                            <div className="input_group">
                                <div className="input_group_sec left">
                                    <div className="input_sec">
                                        <label>Domestic Exhibitions</label>
                                        <div className="input">
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="localExhibitions"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('localExhibitions', v)
                                                }}
                                                value={localExhibitions}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        <label>International Exhibitions</label>
                                        <div className="input">
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="internationalExhibitions"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('internationalExhibitions', v)
                                                }}
                                                value={internationalExhibitions}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="input_group_sec right">
                                    <div className="input_sec">
                                        <label>Number of exhibitions</label>
                                        <div className="input input__no-symbol">
                                            <input
                                                name="numberOfExhibitions"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('numberOfExhibitions', v)
                                                }}
                                                value={numberOfExhibitions}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        <label>Limit per Exhibition</label>
                                        <div className="input">
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="limitPerExhibition"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('limitPerExhibition', v)
                                                }}
                                                value={limitPerExhibition}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    {(this.state.showErrorOfCovar) ? (

                        <Alert type="error">
                            Error: Incoming/Outgoing Limit must not exceed Cover Value.
                        </Alert>

                    ) : null}
                    <button className={`submit ${this.state.dirty ? 'visible' : null}`} type="submit">Update</button>
                </form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05m/components/VariationOptions.tsx